import i18n from '../../i18n/index'
import serviceProvider from '../../services/provider/ProviderService'
import reportService from '../../services/report/ReportSerivce'
import { StorageService } from '../../services/StorageService'
import * as moment from 'moment'
import io from 'socket.io-client'
import ApiService from '../../services/ApiService'
import XLSX from 'xlsx'

export default {
  components: {
  },
  data: () => ({
    providers: [],
    selectedProviders: [],
    rules: {
      required: value => !!value || 'El campo es requerido'
    },
    menuInitialDate: false,
    initialDate: '',
    menuFinalDate: false,
    finalDate: '',
    minDate: '',
    io: null,
    socket: null,
    showDownloadBox: false,
    generatingReport: false,
    link: '',
    fail: false,
    menuInitialDate2: false,
    initialDate2: '',
    menuFinalDate2: false,
    finalDate2: '',
    minDate2: '',
    searchUserTypes: ['POS', 'Poliza', 'Consentido', 'Todos'],
    typeUser: '',
    typeUser2: ''
  }),
  created () {
    this.initSocket()
    this.getProviders()
  },

  computed: {
  },

  watch: {
  },

  methods: {
    initSocket () {
      this.socket = io(process.env.VUE_APP_BACK, {
        transports: [ 'websocket' ] // or [ "websocket", "polling" ]
      })
      this.socket.on('reportReceived', data => {
        this.showDownloadBox = true
        this.generatingReport = true
      })
      this.socket.on('reportGenerated', data => {
        // let columns = XLSX.utils.json_to_sheet(JSON.parse(data))
        // let wb = XLSX.utils.book_new()
        // XLSX.utils.book_append_sheet(wb, columns, 'Reporte')
        // XLSX.writeFile(wb, `Reporte_${moment().format('YYYY-MM-DD')}.xlsx`)
        this.generatingReport = false
        this.link = data
      })
      this.socket.on('reportFailed', data => {
        this.generatingReport = false
        this.fail = true
      })
    },
    async getProviders () {
      try {
        const response = await serviceProvider.getProviders()
        const integratedProvider = StorageService.getIntegratedProvider()
        this.providers = response.data.filter(
          item => item.id !== integratedProvider && item.name !== 'FARMACIA UNIFICADA' && item.name !== '' && item.name !== 'DEMPOS FARMACIA' && item.name !== 'FARMACIAS NOVA'
        )
        this.selectedProviders = ['HELPHARMA']
        // this.providers.unshift({ name: 'INTEGRADOS' })
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: error
        })
      }
    },
    changeInitialDate () {
      let initialDate = moment(this.initialDate).format('YYYY-MM-DD')
      this.minDate = initialDate
      if (this.finalDate !== null & this.finalDate !== undefined && this.finalDate !== '') {
        if (!moment(this.finalDate).isSameOrAfter(initialDate)) {
          this.finalDate = this.minDate
        }
      } else {
        this.finalDate = this.minDate
      }
    },
    changeInitialDate2 () {
      let initialDate2 = moment(this.initialDate2).format('YYYY-MM-DD')
      this.minDate = initialDate2
      if (this.finalDate2 !== null & this.finalDate2 !== undefined && this.finalDate2 !== '') {
        if (!moment(this.finalDate2).isSameOrAfter(initialDate2)) {
          this.finalDate2 = this.minDate
        }
      } else {
        this.finalDate2 = this.minDate
      }
    },
    async generateReportOrders () {
      
      if (this.finalDate === null || this.finalDate === undefined || this.finalDate === '') {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debe seleccionar la fecha final'
        })
        return
      }
      if (this.initialDate === null || this.initialDate === undefined || this.initialDate === '') {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debe seleccionar la fecha inicial'
        })
        return
      }
      const data = {
        providers: this.selectedProviders,
        initialDate: this.initialDate,
        finalDate: this.finalDate,
        typeUser: this.typeUser
      }
      this.fail = false
      this.socket.emit('ordersReport', data)
    },
    async generateReportPendings () {
      if (this.finalDate2 === null || this.finalDate2 === undefined || this.finalDate2 === '') {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debe seleccionar la fecha final'
        })
        return
      }
      if (this.initialDate2 === null || this.initialDate2 === undefined || this.initialDate2 === '') {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'Debe seleccionar la fecha inicial'
        })
        return
      }
      const data = {
        initialDate: this.initialDate2,
        finalDate: this.finalDate2,
        typeUser: this.typeUser2 
      }
      this.fail = false
      this.socket.emit('pendingsReport', data)
    }
  }
}
